export const GET_SCRIPT = 'GET_SCRIPT';
export const GET_DEFAULT_SCRIPT = 'GET_DEFAULT_SCRIPT';
export const GET_INBOUND_SCRIPT = 'GET_INBOUND_SCRIPT';
export const CREATE_LEAD_FROM_SCRIPT = 'CREATE_LEAD_FROM_SCRIPT';
export const SAVE_SCRIPT = 'SAVE_SCRIPT';
